import React, { useContext, useState } from "react";
import "./loanlistaction.scss";
import {
  IconButton,
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  Divider,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from "@mui/icons-material/Clear";
import { useMutation } from "@apollo/client";
//components
import { AuthContext } from "../../../context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";
import { UPDATE_LOAN_STATUS } from "../../../Schema/Loanlist";

export default function ApproveLoan({
  open,
  handleClose,
  editData,
  setRefetch,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const { setAlert } = useContext(AuthContext);

  const [updateLoanStatus] = useMutation(UPDATE_LOAN_STATUS, {
    onCompleted: ({ updateLoanStatus }) => {
      // console.log("updateLoanStatus::", updateLoanStatus);
      if (updateLoanStatus?.isSuccess) {
        setAlert(true, "success", updateLoanStatus?.message);
        setRefetch();
        handleClose()
        setLoading(false);
      } else {
        setAlert(true, "error", updateLoanStatus?.message);
      }
    },
    onError: (error) => {
      console.log(error);
      setAlert(true, "error", error?.message);
      setLoading(false);
    },
  });

  // console.log("editData::", editData);

  const handleFirstApprove = () => {
    setLoading(true);
    updateLoanStatus({
      variables: {
        updateLoanStatusId: editData?._id,
        status:
          editData?.status === "FirstApprove" ? "Approve" : "FirstApprove",
        reason: reason,
      },
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} className="loanlist-action">
      <DialogTitle>
        <Stack direction="row">
          <Typography
            className={language === "kh" ? "dialog-titleKh" : "dialog-titleEn"}
          >
            {t("approve")}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <ClearIcon className="close-icon" />
          </IconButton>
        </Stack>
        <Divider />
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="subtitle1"
          className={language === "kh" ? "simple-textKh" : "simple-textEn"}
        >
          {t("fisrt-approve-title")}
        </Typography>
        <TextField
          fullWidth
          multiline
          size="small"
          placeholder="reason"
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box className="action">
              <Button
                className="btn"
                variant="outlined"
                fullWidth
                disabled={reason === "" ? true : false}
                onClick={handleFirstApprove}
                sx={{ backgroundColor: reason === "" ? "gray" : "#38b14a !important" }}
              >
                {loading ? (
                  "Loading..."
                ) : (
                  <Typography
                    className={language === "kh" ? "suspendKh" : "suspendEn"}
                  >
                    {t("approve")}
                  </Typography>
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
